import React from 'react';
import { useTranslation } from 'react-i18next';

import { getInitials, getInitialsFromFullName } from '../../utils/User';
import {
  ChatHeaderInfo,
  ChatHeaderInfoSubTitle,
  ChatHeaderInfoTitle,
  MemberIcon,
  MemberIconContainer,
  MemberStatusIcon,
  StyledVehicleChatPlaceholder,
  VehicleChatIconContainer,
  VehicleIcon,
} from './SingleChat.styles';

export interface VehicleAndMemberChatHeader {
  title: string;
  organization?: string;
  submitter?: string;
  isUserOnline?: boolean;
  profileImage?: string;
  vehicleImage?: string;
}

interface VehicleAndMemberHeaderProps {
  data: VehicleAndMemberChatHeader;
}

const VehicleAndMemberHeader = ({ data }: VehicleAndMemberHeaderProps) => {
  const { t } = useTranslation();

  if (!data) return <></>;

  const vehiclePicture = data.vehicleImage;
  const initials = data.submitter ? getInitialsFromFullName(data.submitter) : getInitials(data.organization);

  const renderSubtitle = () =>
    data.organization
      ? t('components.chat.organizationDetail', { name: data.organization })
      : t('components.chat.submitterDetail', { name: data.submitter });

  return (
    <>
      <VehicleChatIconContainer>
        {vehiclePicture ? <VehicleIcon src={vehiclePicture} /> : <StyledVehicleChatPlaceholder />}
        <MemberIconContainer>
          <MemberIcon text={initials} size="sm" src={data.profileImage} />
          {data.isUserOnline && <MemberStatusIcon />}
        </MemberIconContainer>
      </VehicleChatIconContainer>
      <ChatHeaderInfo>
        <ChatHeaderInfoTitle>{data.title}</ChatHeaderInfoTitle>
        <ChatHeaderInfoSubTitle>{renderSubtitle()}</ChatHeaderInfoSubTitle>
      </ChatHeaderInfo>
    </>
  );
};

export default VehicleAndMemberHeader;
